// extracted by mini-css-extract-plugin
module.exports = {"Heading":"ContactDetailsCard_Heading__2_QA4","Rows":"ContactDetailsCard_Rows__3tyvA"};